var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiQuiz = function SvgAiQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 23"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 14.667,
    height: 14.667,
    x: 13.667,
    y: 0.667,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.333,
    r: 3,
    fill: "#CBFF88",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M10.333 13.333h14v2H21v3.333H10.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillRule: "evenodd",
    d: "M13.667 3.594a.26.26 0 0 1 .26-.261h11.479a.26.26 0 0 1 .26.26v8.61a.26.26 0 0 1-.076.184l-2.87 2.87a.26.26 0 0 1-.184.076h-8.609a.26.26 0 0 1-.26-.26zm.521.26v10.957h8.24l2.717-2.716v-8.24z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M16.536 10.637V8.811h.261c.765 0 1.212-.13 1.467-.334.24-.192.36-.49.36-.97 0-.45-.167-.77-.402-.979a1.36 1.36 0 0 0-.903-.325c-.336 0-.663.112-.903.325-.235.21-.401.528-.401.979a.26.26 0 0 1-.522 0c0-.593.225-1.056.577-1.37a1.88 1.88 0 0 1 1.249-.456c.447 0 .902.148 1.25.457.351.313.576.776.576 1.369 0 .563-.142 1.048-.555 1.378-.352.282-.862.416-1.532.442v1.31a.26.26 0 0 1-.522 0M17.058 12.724a.26.26 0 1 1-.522 0v-.521a.26.26 0 1 1 .522 0zM23.84 5.942a.26.26 0 1 1 0 .521h-2.608a.26.26 0 0 1 0-.521zM23.84 8.029a.26.26 0 1 1 0 .521h-2.608a.26.26 0 0 1 0-.521zM23.84 10.116a.26.26 0 1 1 0 .521h-4.173a.26.26 0 0 1 0-.521z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillRule: "evenodd",
    d: "M22.797 12.463v1.98l1.979-1.98zm-.522-.26a.26.26 0 0 1 .261-.261h2.87a.261.261 0 0 1 .184.445l-2.87 2.87a.26.26 0 0 1-.445-.185z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m34.5 0 .99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99z"
  })));
};
export { SvgAiQuiz as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-quiz-21bd810c3b87f7edf9b52db0cd836789.svg";